import mergeVariables from '../../fe-brary-internals/merge-variables';
import base from '../../base';
import typography from './typography';
import palette from './colours/palette';
import tints from './colours/tints';
import messages from './components/messages';
import form from './components/form';
import input from './components/input';

// prettier-ignore
export default mergeVariables(
// colours
tints, palette,
// typography
base.typography, typography,
// globals
base.grid, base.layers, base.spacing,
// components
base.components.icons, base.components.messages, messages, base.components.form, form, base.components.input, input, base.components.buttons, base.components.social)({});